import { gql } from "graphql-tag";

const getAllocationId = gql`
  query AllocationById($allocationByIdId: Int!) {
  allocationById(id: $allocationByIdId) {
    questionary {
      id
      name
    }
  }
}
`;

const getCuestionarioId = gql`
  query query($Id: Int!) {
    questionnaireById(id: $Id) {
      id
      categories {
        id
        parent {
          id
        }
        questions {
          id
          required
          order
          description
          answers_options {
            id
            score
            description
          }
          weighting
        }
        description
        name
        weighting
      }
      status
      shortName
      name
      semaphores {
        color
        value_1
        value_2
      }
    }
  }
`;

const getInstitutionSurveyData = gql`
query Query($access: String!, $questionnaireId: Float!, $allocationToken: String) {
  getInstitutionSurveyData(access: $access, questionnaireId: $questionnaireId, allocationToken: $allocationToken) {
    catalogs {
      generos
      edades
      antiguedades
      nivelesFormacion
      nivelesJerarquicos
      areasDepartamentos
      sucursales
    }
    questionnaire {
      id
      categories {
        id
        parent {
          id
        }
        questions {
          id
          required
          order
          description
          answers_options {
            id
            score
            description
          }
          weighting
        }
        description
        name
        weighting
      }
      status
      shortName
      name
      semaphores {
        color
        value_1
        value_2
      }
    }
  }
}`;

export {
  getAllocationId,
  getCuestionarioId,
  getInstitutionSurveyData,
}